import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getAll = (params, urlParams) => {
  return axios.request({
    url: '/vehicleinfo/all' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/vehicleinfo/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/vehicleinfo/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const addObj = (params, urlParams) => {
  return axios.request({
    url: '/vehicleinfo/add' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const modifyObj = (params, urlParams) => {
  return axios.request({
    url: '/vehicleinfo/modify' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const deleteObj = (params, urlParams) => {
  return axios.request({
    url: '/vehicleinfo/' + params.id + '' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}

export const getMyAll = (params, urlParams) => {
  return axios.request({
    url: '/vehicleinfo/getmyall' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getMyPage = (params, urlParams) => {
  return axios.request({
    url: '/vehicleinfo/getmypage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const changePicture = (params, urlParams) => {
  return axios.request({
    url: '/vehicleinfo/changepicture/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const addCheck = (params, urlParams) => {
  return axios.request({
    url: '/vehicleinfo/addcheck/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const modifyCheck = (params, urlParams) => {
  return axios.request({
    url: '/vehicleinfo/modifycheck/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const submit = (params, urlParams) => {
  return axios.request({
    url: '/vehicleinfo/submit/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const cancel = (params, urlParams) => {
  return axios.request({
    url: '/vehicleinfo/cancel/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const sold = (params, urlParams) => {
  return axios.request({
    url: '/vehicleinfo/sold/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const offShelves = (params, urlParams) => {
  return axios.request({
    url: '/vehicleinfo/offshelves/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

